import React from 'react'
import InstructorNavbar from '../components/instructor/InstructorNavbar'
import QuizInstructorDetails from '../components/quiz/QuizInstructorDetails'

const QuizInstructorDetailsPage = () => {
  return (
    <>
    
    <InstructorNavbar/>
    <QuizInstructorDetails/>
    </>
  )
}

export default QuizInstructorDetailsPage